<div class="job-offers" id="job-offers">
  <div class="job-offers__container container">
    <div class="job-offers__section row">
      <div
        class="job-offers__intro d-flex flex-column col-md-6"
        data-aos="fade-right"
        data-aos-easing="linear"
        data-aos-duration="500"
      >
        <h2 class="job-offers__intro-title m-0">
          Do you want to embark on a new journey with us?
        </h2>

        <p class="job-offers__intro-text _1r m-0">
          When you become a part of our team, you join a dynamic company that
          truly values its employees. Collaborate with highly skilled
          colleagues, harness the power of new technologies, and contribute to
          cutting-edge projects that push the boundaries of innovation.
          Experience a rewarding career in software development with long-term
          growth opportunities.
        </p>

        <button
          class="job-offers__intro-btn btn btn-primary d-inline-block"
          type="button"
        >
          <a class="display-button" routerLink="../careers">
            Let's see job offers</a
          >
        </button>
      </div>
      <div
        class="job-offers__photo col-12 offset-md-1 col-md-5"
        data-aos="fade-left"
        data-aos-easing="linear"
        data-aos-duration="500"
      >
        <img
          class="job-offers__photo-img"
          ngSrc="../../../../assets/img/about-us-home.webp"
          width="1979"
          height="1365"
          alt="Nice Project Team to join"
        />
      </div>
    </div>
  </div>
</div>
